module.exports = {
  nonWriteoffList: 'Account balances',
  writeoffList: 'Clearance Query',
  selectHedgingTheInvoice: 'Please check and select the hedging',
  return: 'Return',
  query: 'Query',
  writeOffs: 'Clearance',
  confirm: 'Confirm',
  hedgingWriteOffs: 'Offsetting',
  actualReceiptAndPayment: 'Actual receipt and payment',
  revenueAndExpenditureMethod: 'Revenue and expenditure method',
  all: 'All',
  receivables: 'Receivables',
  payables: 'Payables',
  feeType: 'ExpenseType',
  domestic: 'Domestic',
  international: 'Overseas',
  writeOffMode: 'Clearance Mode',
  charges: 'Expense',
  invoice: 'Invoice',
  bill: 'Bill',
  accountStatement: 'Account statement',
  paymentRequest: 'Payment request',
  revenueAndExpenditureDate: 'Revenue and expenditure date',
  writeOffSerialNumber: 'Clearance serial number',
  settleAccountsTo: 'SettlementObject',
  chargeRemark: 'Charge Remark',
  applyState: 'Apply State',
  applicationNo: 'Application No',
  businessNumber: 'Job No.',
  theOppositeSideInvoiceNo: 'CounterpartInvoiceNo',
  consignationCompany: 'Consignation company',
  settlementAgent: 'Settlement agent',
  currency: 'Currency',
  applicant: 'Applicant',
  businessType: 'Business type',
  dateOfApplication: 'Date of application',
  businessDate: 'JobDate',
  operation: 'Operation',
  sales: 'Sales',
  wroteOffOrNot: 'Clearance or not',
  businessReferenceNumber: 'Business reference number',
  businessStatus: 'Business Status',
  separateNumber: 'HouseB/LNo',
  paymentNotificationNo: 'Payment notification No',
  applicationDepartment: 'Application Department',
  paymentPeriod: 'PaymentTimeLimit',
  amount: 'Amount',
  theAmountOfWriteOffs: 'Clearance Amount',
  approvalStatus: 'Approval status',
  businessAuditor: 'Business auditor',
  businessAuditDate: 'Business audit date',
  departmentAuditor: 'Department auditor',
  departmentAuditDate: 'Department audit date',
  officeAuditor: 'Office auditor',
  officeAuditDate: 'Office audit date',
  financialAuditor: 'Financial auditor',
  financialAuditDate: 'Financial audit date',
  financeVerifyDate: 'Financial verify date',
  verificationStatus: 'Verification status',
  remark: 'remark',
  totalAmountNtWrittenOff: 'Total amount not written off',
  methodOfPayment: 'Method of payment',
  claimState: 'Claim State',
  prePayment: 'Pre-receivedOrNot',
  lastTimeBalance: 'Last time balance',
  thisTimeWriteOff: 'This time Clearance',
  thisTimeBalance: 'ThisBalance',
  otherCurrency: 'Other Currency',
  paymentMethod: 'ReceivableMethod',
  bankReceiptStatus: 'Bank receipt status',
  ourSideBank: 'Our side bank',
  ourSideAccount: 'Our side account',
  proofNo: 'FinancialVoucherNo',
  usePaymentRecord: 'Use payment record',
  paymentAmount: 'Payment amount',
  receiptAmount: 'Receipt amount',
  theOppositeSideCompany: 'CounterpartCompany',
  theOppositeSideBank: 'CounterpartBank',
  theOppositeSideAccount: 'CounterpartAccount',
  exchangeGainsAndLosses: 'Exchange gains and losses',
  financialCharges: 'Financial charges',
  oddment: 'Oddment',
  originalCurrencyExchangeDifference: 'Original Currency Exchange Difference',
  writeOffRemarks: 'Clearance remarks',
  paymentReceivedDate: 'Payment received date',
  paymentDate: 'Payment date',
  confirmToWriteOff: 'Confirm to Write-Off',
  cancel: 'Cancel',
  totalGainsAndLosses: 'Total gains and losses',
  date: 'Date',
  method: 'Method',
  use: 'Use',
  cancelUsed: 'Cancel used',
  record: 'record',
  chargeItem: 'ExpensesName',
  reconciliationStatus: 'Reconciliation status',
  type: 'Type',
  writeOffExchangeRate: 'Clearance Exchange rate',
  total: 'Total',
  confirmedCharge: 'Confirmed charge',
  subTotal: 'Sub total',
  invoiceNo: 'Invoice No',
  invoiceHeader: 'Invoice header',
  invoiceDate: 'Invoice date',
  revenueAndExpenditureType: 'Revenue and expenditure type',
  billNo: 'Bill No',
  accountStatementNo: 'Account Statement No',
  billType: 'Bill type',
  useReceiptRecord: 'Use receipt record',
  cancelUsedReceiptRecord: 'cancel used receipt record',
  cancelUsedPaymentRecord: 'cancel used payment record',
  mbl: 'MBL',
  itemNo: 'Project number',
  bankReceiptNo: 'Bank receipt No',
  settlementCompany: 'Settlement Company',
  solicitationType: 'ResourceOfFreight',
  writeOffPerson: 'Clearance person',
  amountRange: 'Amount range',
  writeOffDate: 'Clearance date',
  RecheckDate: 'ReviewDate',
  advanceMoneyOrNot: 'DisbursementOrNot',
  recheckOrNot: 'ReviewOrNot',
  proofOrNot: 'VoucherGenerateOrNot',
  proofDate: 'VoucherDate',
  paymentType: 'Payment type',
  prepaidOrNot: 'Prepaid or not',
  theAmountOfWrittenOff: 'The amount of written off',
  balance: 'Balance',
  actualReceiptAmount: 'Actual receipt amount',
  actualPaymentAmount: 'Actual payment amount',
  creator: 'Creator',
  recheck: 'Re-check',
  invalid: 'Invalid',
  invoicingInformation: 'Invoicing information',
  unchecked: 'Unchecked',
  writeOffCurrency: 'Clearance Currency',
  chargeOriginalCurrency: 'Charge original currency',
  chargeOriginalAmount: 'Charge original amount',
  chargeOriginalExchangeRate: 'Charge original exchange rate',
  rmbAmount: 'RMB Amount',
  usdAmount: 'USD Amount',
  cancelRecheck: 'Cancel Recheck',
  editWriteOff: 'Edit Clearance',
  cancelWriteOff: 'Cancel Clearance',
  viewDetails: 'View details',
  exportExcel: 'Export Excel',
  proof: 'Proof',
  refreshRate: 'Refresh rate',
  refreshActualReceiptAndPaymentAmount: 'Refresh Actual Receipt and Payment Amount',
  writeOffType: 'Clearance type',
  vesselVoyage: 'Vessel/Voyage',
  containerSizeAmount: 'Container size/amount',
  monetaryEquivalent: 'Monetary equivalent',
  customerService: 'Customer service',
  totalWriteOffs: 'Total Clearance',
  totalEquivalent: 'Total equivalent',
  exportToExcel: 'Export to excel',
  exportPDF: 'Export PDF',
  print: 'Print',
  close: 'Close',
  dayOfCreditTerm: 'Credit Term',
  billPaymentNo: 'PaymentNoticeNo',
  totalCurrency: ' TotalInEachCurrency',
  rateBy: 'Writeoff Exchange Rate',
  rateByInvoice: 'By Invoice Exchange Rate',
  rateByAverage: 'By Average Exchange Rate',
  businessCreateDate: 'JobCreateDate',
  invoicingStatus: 'Invoicing Status',
  searchReqCondition: 'AtLeast1QueryCriteria',
  dateTo: 'To',
  lockCheckBoxDate: 'Data Older than 2 years',
  queryLotsOfData: 'Data Older than 2 years',
  writeOffDateNotEmpty: 'WriteOffDate Not Empty',
  unlockWriteOffDateQuery: 'Query Data Two Years Ago, May Be Slower, Determine The Cancel Date Lock?',
  voucherNo: 'voucher No',
  voucherCreateDate: 'voucher CreateDate',
  chargeSettleAccountsTo: 'Charge settle accounts to',
  update: 'update',
  strip: 'strip',
  targetVoucherNo: 'Target Voucher No',
  voucherDate: 'Voucher Date2',
  sourceRateDiff: 'Exchange difference',
  warehouseNo: 'WarehouseNo',
  userDefinedField1: 'User Defined Field 1',
  userDefinedField2: 'User Defined Field 2',
  userDefinedField3: 'User Defined Field 3',
  havingInvoiceingNoOrNot: 'Having invoiceing No or not',
  selectActualReceiptAndPayment: 'Select Actual receipt and payment',
  noCurrencyRate: 'Unable to find the exchange rate of currency {0}, please maintain in time!',
  selectMethodOfPayment: 'Please select Method of payment.',
  selectOurSideBank: 'Please select Our side bank.',
  rateByCharge: 'ByChargeExchangeRate',
  preExchangeDifference: 'PreExchangeDifference',
  bankWaterNo: 'BankWaterNo',
  ReceivableSoldAmount: 'Receivable sold amount',
  PayableSoldAmount: 'Payable sold amount',
  ActualAmountReceivable: 'Actual amount receivable',
  ActualAmountPayable: 'Actual amount payable',
  ChargeOriginTotalAmount: 'Charge origin total amount',
  FinancialExpensesBeAllocated: 'Should financial expenses be allocated',
  FinanceExpensesAllocation: 'Allocation of financial expenses',
  ChargingDirection: 'Charging direction',
  SelectChargeItem: 'Please select charge item',
  SelectAccountObject: 'Please select account object',
  FinanceChargeShareJobTip: 'After checking the box, the financial expenses will be automatically allocated evenly to all transactions included in this write-off during clearance.',
  NotSyncCannotModify: 'The data synchronized with the cloud platform cannot be modified or revoked!',
  invoiceTitle: 'Invoice Title',
  writeoffMatchStatus: 'Match Status',
  matchStatusUnmatched: 'Unmatched',
  matchStatusAuto: 'Auto Written Off',
  matchStatusManual: 'Manual Write-off',
  matchStatusNoNeed: 'No Need Write-off',
  matchStatusReason: 'Reason for Status Change',
  writeoffSeqNoSource: 'Serial No. Source',
  sourceImport: 'Import',
  sourceSystem: 'System',
  modifyMatchStatus: 'Modify Match Status',
  modifyStatus: 'Modify Status',
  modifyReason: 'Reason',
  confirmModify: 'Confirm',
  modifySuccess: 'Successfully modified {0} records',
  lockedCannotModify: 'Locked, cannot modify',
  containsLockedStatus: 'Contains locked status, please select unmatched records',
  pleaseSelectUnmatched: 'Please select unmatched records',
  selectAtLeastOne: 'Please select at least one record'
}
